import api from '../api'

function renderRewardtList(data) {
  let liHtml = ''
  data.map(e => {
    let tagHtml = ''
    if (e.second_tags.length > 0) {
      for (var i = 0; i < e.second_tags.length; i++) {
        tagHtml += `<a target="_blank" href='${api.host}/qa/tag_${e.second_tags[i].id}'><span>#${e.second_tags[i].name}</span></a>`
      }
    }
    liHtml += `<li>
  <div class="list_item_tag_t">
      <div class="list_item_tag">
          ${tagHtml}
      </div>
      <div class="list_item_title">
      <a href="${e.share.url}" target="_blank">${e.title}</a>
      </div>
      <div class="list_item_reward">
          ${
            +e.reward_amount !== 0
              ? `<span>赏金 ¥${(+e.reward_amount / 100).toFixed(2)}</span>`
              : ''
          }
          ${
            +e.platform_reward_amount !== 0
              ? `<span>壹心理追加 ¥${(+e.platform_reward_amount / 100).toFixed(
                  2
                )}</span>`
              : ''
          }
      </div>
      <div class="sameFeel_div ${
        +e.is_same_feeling === 1 ? 'has-feel' : ''
      }" data-question_id='${e.id}'>
          <p>
              <span>${e.same_feeling_num}</span>人</p>
          <p>有同感</p>
      </div>
  </div>
  <div class="list_item_tag_b">
      <ul>
          <li class="answer">
              <a href="${e.share.url}" target="_blank">
                  <i class="yxlicon icon-askwrite"></i>我要回答</li>
              </a>
          <li class="follow" data-question_id='${e.id}'>
              <i class="yxlicon ${
                +e.is_favorite === 1 ? 'icon-instar' : 'icon-unstar'
              }"></i>
              <label>${+e.is_favorite === 1 ? '已关注' : '关注'}</label>
          </li>
          <li class="share" data-title='${e.share.title}' data-cover='${
      e.share.cover
    }' data-desc='${e.share.description}' data-url="${e.share.url}">
              <i class="yxlicon icon-fenxiang"></i>分享</li>
      </ul>
  </div>
</li>`
  })
  return liHtml
}

module.exports = renderRewardtList



// WEBPACK FOOTER //
// ./src/pages/ask/askIndex/render/rewardList.js